import { render, staticRenderFns } from "./RequestGlobalSearchByPhone.vue?vue&type=template&id=45f98719&scoped=true&"
import script from "./RequestGlobalSearchByPhone.vue?vue&type=script&lang=js&"
export * from "./RequestGlobalSearchByPhone.vue?vue&type=script&lang=js&"
import style0 from "./RequestGlobalSearchByPhone.vue?vue&type=style&index=0&id=45f98719&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f98719",
  null
  
)

export default component.exports